module.exports = __webpack_public_path__ + "static/6a428f673bb4f21a15de643f166a78e3470bdfec790299db68067a23959b0e5e-221ebd1f54b9ee7cfb1da9829b35b9ab.png";